
import AdminLogs from './logs';
import AdminUsers from './users';
import AdminSearch from './search';
import AdminPolicy from './policy';
import AdminApiKeys from './api-keys';
import AdminSettings from './settings';
import AdminResource from './resource';
import AdminDashboard from './dashboard';
import AdminUserRoles from './user-roles';
import AdminAuditTrail from './audit-trail';
import AdminConsultations from "./consultations";
import AdminPrescriptions from "./prescriptions";
import AdminResourceActions from './resource-actions';
import AdminPermissionSchema from './permission-schema';

import AdminGeoData from './geo-data';
import AdminPharmacyProfiles from './pharmacy-profiles';

import AdminMedicationReports from './medication-report';
import AdminConsultationReports from './consultation-report';
import AdminPatientsSeenReports from './patients-seen-report';

export default class PharmacyJwtServices {
  axiosIns = null;
  jwtConfig = null;

  users = null;
  search = null;
  policy = null;
  settings = null;
  resource = null;
  userRoles = null;
  resourceActions = null;
  permissionSchema = null;

  logs = null;
  auditTrail = null;

  consultations = null;
  prescriptions = null;
  pharamcyProfiles = null;

  medicationReports = null;
  consultationReports = null;
  adminPatientsSeenReports = null;

  geoData = null;

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;

    this.logs = new AdminLogs(axiosIns, jwtConfig);
    this.users = new AdminUsers(axiosIns, jwtConfig);
    this.search = new AdminSearch(axiosIns, jwtConfig);
    this.policy = new AdminPolicy(axiosIns, jwtConfig);
    this.apiKeys = new AdminApiKeys(axiosIns, jwtConfig);
    this.settings = new AdminSettings(axiosIns, jwtConfig);
    this.resource = new AdminResource(axiosIns, jwtConfig);
    this.dashboard = new AdminDashboard(axiosIns, jwtConfig);
    this.userRoles = new AdminUserRoles(axiosIns, jwtConfig);
    this.auditTrail = new AdminAuditTrail(axiosIns, jwtConfig);

    this.geoData = new AdminGeoData(axiosIns, jwtConfig);
    this.consultations = new AdminConsultations(axiosIns, jwtConfig);
    this.prescriptions = new AdminPrescriptions(axiosIns, jwtConfig);
    this.pharmacyProfiles = new AdminPharmacyProfiles(axiosIns, jwtConfig);

    this.medicationReports = new AdminMedicationReports(axiosIns, jwtConfig);
    this.consultationReports = new AdminConsultationReports(axiosIns, jwtConfig);
    this.adminPatientsSeenReports = new AdminPatientsSeenReports(axiosIns, jwtConfig);

    this.resourceActions = new AdminResourceActions(axiosIns, jwtConfig);
    this.permissionSchema = new AdminPermissionSchema(axiosIns, jwtConfig);
  }
}
